const useEmbedCheck = () => {
    return window.location !== window.parent.location
}

export default useEmbedCheck;